"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "resource_items_cont" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_player_resource = (0, vue_1.resolveComponent)("player-resource");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createVNode)(_component_player_resource, {
            type: _ctx.Resource.MEGACREDITS,
            count: _ctx.player.megaCredits,
            production: _ctx.player.megaCreditProduction,
            resourceProtection: _ctx.player.protectedResources.megacredits,
            productionProtection: _ctx.player.protectedProduction.megacredits
        }, null, 8, ["type", "count", "production", "resourceProtection", "productionProtection"]),
        (0, vue_1.createVNode)(_component_player_resource, {
            type: _ctx.Resource.STEEL,
            count: _ctx.player.steel,
            production: _ctx.player.steelProduction,
            value: _ctx.player.steelValue,
            resourceProtection: _ctx.player.protectedResources.steel,
            productionProtection: _ctx.player.protectedProduction.steel
        }, null, 8, ["type", "count", "production", "value", "resourceProtection", "productionProtection"]),
        (0, vue_1.createVNode)(_component_player_resource, {
            type: _ctx.Resource.TITANIUM,
            count: _ctx.player.titanium,
            production: _ctx.player.titaniumProduction,
            value: _ctx.player.titaniumValue,
            resourceProtection: _ctx.player.protectedResources.titanium,
            productionProtection: _ctx.player.protectedProduction.titanium
        }, null, 8, ["type", "count", "production", "value", "resourceProtection", "productionProtection"]),
        (0, vue_1.createVNode)(_component_player_resource, {
            type: _ctx.Resource.PLANTS,
            count: _ctx.player.plants,
            production: _ctx.player.plantProduction,
            resourceProtection: _ctx.player.protectedResources.plants,
            productionProtection: _ctx.player.protectedProduction.plants
        }, null, 8, ["type", "count", "production", "resourceProtection", "productionProtection"]),
        (0, vue_1.createVNode)(_component_player_resource, {
            type: _ctx.Resource.ENERGY,
            count: _ctx.player.energy,
            production: _ctx.player.energyProduction,
            resourceProtection: _ctx.player.protectedResources.energy,
            productionProtection: _ctx.player.protectedProduction.energy
        }, null, 8, ["type", "count", "production", "resourceProtection", "productionProtection"]),
        (0, vue_1.createVNode)(_component_player_resource, {
            type: _ctx.Resource.HEAT,
            count: _ctx.player.heat,
            production: _ctx.player.heatProduction,
            value: _ctx.canUseHeatAsMegaCredits ? 1 : 0,
            resourceProtection: _ctx.player.protectedResources.heat,
            productionProtection: _ctx.player.protectedProduction.heat
        }, null, 8, ["type", "count", "production", "value", "resourceProtection", "productionProtection"])
    ]));
}
